export default __webpack_public_path__ + "static/media/dust-collector-bag-filters.9c141a78.jpg";